module.exports = __webpack_public_path__ + "img/korma.38034e05.jpg";